/**
 * @voltxampere/ui — Switch (Anahtar) · open SPST
 *
 * Two contact dots at x=10 and x=28 with the lever shown lifted
 * (open state) up to (26, 5). Sprint 11+ may animate to the closed
 * (lever flat) position when the schematic state flips.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT } from "./constants.js";
export const switchSymbol = {
    id: "switch",
    nameTr: "Anahtar",
    nameEn: "Switch",
    shortcut: "S",
    category: "passive",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 0, y: 13, polarity: "bi" },
        { x: 40, y: 13, polarity: "bi" },
    ],
    defaultLabel: "SW",
    renderSVG: () => [
        `<line x1="0" y1="13" x2="10" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<circle cx="10" cy="13" r="1.5" fill="${STROKE_IVORY}"/>`,
        `<line x1="10" y1="13" x2="26" y2="5" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<circle cx="28" cy="13" r="1.5" fill="${STROKE_IVORY}"/>`,
        `<line x1="28" y1="13" x2="40" y2="13" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
    ].join(""),
};
//# sourceMappingURL=switch.js.map